enum PaymentStatus {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
  POSTPONED = "POSTPONED",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export default PaymentStatus;
